import { toast } from "react-toastify";
import FastCashRepository from "../../Repository/FastCashRepository";
import {
  fastCashAdded,
  removeCurrentFastCash,
  removeFastCash,
  removeFastCashAmount,
} from "./fastCashSlice";

export const createFastCashEntry = async (
  code,
  name,
  comment,
  amount,
  date,
  _id,
  dispatch
) => {
  try {
    let { data } = await FastCashRepository.fastcashModel({
      request: {
        method: "saveFastCashEntry",
        data: {
          _id: _id,
          itemName: name,
          detail: comment,
          amount: amount,
          company_code: code,
          date: date,
        },
      },
    });
    if (data.response.status.statusCode == 200) {
      toast.configure();
      toast.success("Entry Added Successfully");
    } else {
      dispatch(removeFastCashAmount({ _id: _id, amount: amount }));
      toast.configure();
      toast.error("Entry not added");
    }
  } catch (err) {
    console.log(err);
    toast.configure();
    toast.error("Error");
  }
};
export const createFastCash = async (code, name, date, _id, dispatch) => {
  try {
    let { data } = await FastCashRepository.fastcashModel({
      request: {
        method: "saveFastCash",
        data: {
          _id: _id,
          name: name,
          date: date,
          company_code: code,
        },
      },
    });
    if (data.response.data.cashId != "") {
      toast.configure();
      toast.success("Fast Cash Added Successfully");
      return "success";
    } else {
      dispatch(removeCurrentFastCash());
      toast.configure();
      toast.error("Fast Cash not added");
      return "fail";
    }
  } catch (err) {
    console.log(err);
  }
};
export const deleteFashCash = async (fastCash, index, dispatch) => {
  try {
    let { data } = await FastCashRepository.fastcashModel({
      request: {
        method: "deleteFastCash",
        data: {
          _id: fastCash._id,
        },
      },
    });
    if (data.response.status.statusCode == 200) {
      toast.configure();
      toast.success("Fast Cash Deleted Successfully");
    } else {
      dispatch(fastCashAdded({ index: index, user: fastCash }));
      toast.configure();
      toast.error("Fast Cash not Deleted");
    }
  } catch (err) {
    console.log(err);
  }
};
